module.exports = new __parcel__URL__("user-gray-dark.f2ef58b1.svg").toString();